import{stringRepeat as t}from"../stringRepeat.js";var e=function(e,n,r){return void 0===r&&(r=" "),n=Math.floor(n),e.length>=n?"":((n-=e.length)>r.length&&(r+=t(r,n/r.length)),r.slice(0,n))};export{e as stringPad};
//# sourceMappingURL=stringPad.js.map
